// libs
import styled from "@emotion/styled";

// mixins
import { BaseButton } from "shared/styles/mixin";

export const Container = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`;

export const FkContainer = styled.div`
    width: 100%;
    height: 100%;
    overflow-x: hidden;
`;

export const FkInnerContainer = styled.div`
    height: 100%;
    width: calc(100% + 20px);
    padding-right: 20px;
    overflow-y: auto;
`;

export const FkHandle = styled(BaseButton)`
    position: absolute;
    width: 3px;
    background: #000;
    right: -2px;
    top: 0;
    will-change: transform;
    &.dragging,
    &:hover {
        width: 6px;
        cursor: pointer;
        border-radius: 3px;
        right: -3px;
    }
`;
